import axios from '../config/axios';

class ConversationService {
  // Get all conversations for the current user
  async getConversations() {
    try {
      const response = await axios.get('/conversations');
      return response.data;
    } catch (error) {
      console.error('Error fetching conversations:', error);
      // Re-throw auth errors so callers can redirect to login
      if (error.response && error.response.status === 401) {
        throw error;
      }
      return [];
    }
  }

  // Get a specific conversation
  async getConversation(id) {
    try {
      const response = await axios.get(`/conversations/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching conversation:', error);
      return null;
    }
  }

  // Create a new conversation
  async createConversation(conversation) {
    try {
      const response = await axios.post('/conversations', conversation);
      return response.data;
    } catch (error) {
      console.error('Error creating conversation:', error);
      throw error;
    }
  }

  // Update a conversation
  async updateConversation(id, updates) {
    try {
      const response = await axios.put(`/conversations/${id}`, updates);
      return response.data;
    } catch (error) {
      console.error('Error updating conversation:', error);
      throw error;
    }
  }

  // Delete a conversation
  async deleteConversation(id) {
    try {
      const response = await axios.delete(`/conversations/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting conversation:', error);
      throw error;
    }
  }

  // Sync all local conversations to server
  async syncConversations(conversations) {
    try {
      const response = await axios.post('/conversations/sync', conversations);
      return response.data;
    } catch (error) {
      console.error('Error syncing conversations:', error);
      return null;
    }
  }

  // Load conversations from server and merge with local
  async loadAndMergeConversations(localConversations) {
    try {
      const serverConversations = await this.getConversations();
      
      // Create a map of server conversations by ID
      const serverMap = new Map(serverConversations.map(conv => [conv.id, conv]));
      
      // Merge local conversations (prefer server version if exists)
      const merged = localConversations.map(localConv => {
        const serverConv = serverMap.get(localConv.id);
        if (serverConv) {
          // Use server version but keep any local messages that might be newer
          if (localConv.updatedAt > serverConv.updated_at) {
            return localConv;
          }
          return serverConv;
        }
        return localConv;
      });
      
      // Add any server conversations not in local
      serverConversations.forEach(serverConv => {
        if (!merged.find(conv => conv.id === serverConv.id)) {
          merged.push(serverConv);
        }
      });
      
      return merged;
    } catch (error) {
      console.error('Error loading and merging conversations:', error);
      return localConversations;
    }
  }
}

export default new ConversationService();
